/**
 * @generated SignedSource<<19b6222beb79a1e43c09cb615d42eed8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AppSelector_userDataFragment$data = {
  readonly email?: string | null | undefined;
  readonly " $fragmentType": "AppSelector_userDataFragment";
};
export type AppSelector_userDataFragment$key = {
  readonly " $data"?: AppSelector_userDataFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppSelector_userDataFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AppSelector_userDataFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "email"
        }
      ],
      "type": "AtlassianAccountUser"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "d8c04948a0582763e6387708a6adf3e3";

export default node;
